module.exports = __webpack_public_path__ + "img/specification_item_bg.aaf5564f.jpg";